(function() {
  const cartCounter = document.getElementById('cart-counter');
  const cartCounterMobile = document.getElementById('cart-counter-mobile');
  if (cartCounter.innerText !== '0') {
    cartCounter.style.display = 'inline-flex';
    cartCounterMobile.style.display = 'inline-flex';
  }
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelector('.arrow-up').addEventListener('click', this.onButtonClick.bind(this));
    this.querySelector('.arrow-down').addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
     alert();
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


/**
 * Custom Chaddsford Code
 */
class ChaddsfordNumberInput extends HTMLElement {
  constructor() {
    super();

    this.arrowUp = this.querySelector('.arrow-up');
    this.arrowDown = this.querySelector('.arrow-down');
    this.numberInput = this.querySelector('[type="number"]');
    this.arrowUp.addEventListener('click', this.arrowUpClick.bind(this));
    this.arrowDown.addEventListener('click', this.arrowDownClick.bind(this));
  }

  arrowUpClick() {
    let value = parseInt(this.numberInput.value);
    this.numberInput.value = ++value;
  }

  arrowDownClick() {
    let value = parseInt(this.numberInput.value);
    if (value > 1) {
      this.numberInput.value = --value;
    }
  }
}

customElements.define('chaddsford-number-input', ChaddsfordNumberInput);

(function() {
  const announcementBar = document.getElementById('announcement-bar');
  const body = document.body;
  if (announcementBar) {
    if (!sessionStorage.getItem('show-announcement-bar')) {
      announcementBar.classList.add('active');
      const closeBtn = document.getElementById('announcement-bar-close-button');
      const barHeight = announcementBar.getBoundingClientRect().height;
      const nav = document.getElementById('shopify-section-header');
      nav.style.top = `${barHeight}px`;
      body.style.paddingTop = `${barHeight}px`;
      closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          announcementBar.style.display = "none";
          body.style.paddingTop = 0;
          nav.style.top = 0;
          sessionStorage.setItem('show-announcement-bar', 'false');
      });
    }
  }
})();

if (!customElements.get('product-list-form')) {
  customElements.define('product-list-form', class ProductListForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartCounter = document.getElementById('cart-counter');
      this.cartCounterMobile = document.getElementById('cart-counter-mobile');
      this.mainId = this.querySelector('form input[name="id"]').value;
      this.productCardPriceSwitcher = document.getElementById('price-item-regular-' + this.mainId);
      if (this.productCardPriceSwitcher) {
       this.updatePrice();
      }
    }
  
    updatePrice = () => {
      let productSelect = this.form.querySelector('select[name="Size"]');
      if (!productSelect) {
        productSelect = this.form.querySelector('select[name="Quantity"]');
      }
      let firstPrice = this.productCardPriceSwitcher.dataset.firstPrice;
      if (productSelect) {
        firstPrice = productSelect.selectedOptions[0].dataset.price;
      }
      
      const { productCardPriceSwitcher } = this;
      const productCountInput = this.form.querySelector('.product-list-count');
      const arrowUp = this.form.querySelector('.arrow-up');
      const arrowDown = this.form.querySelector('.arrow-down');

      productCountInput.addEventListener('input', calculateTotal);
      productCountInput.addEventListener('change', calculateTotal);
      arrowDown.addEventListener('click', calculateTotal);
      arrowUp.addEventListener('click', calculateTotal);

      if (productSelect) {
        productSelect.addEventListener('change', calculateTotal);
      }

      function calculateTotal (e) {
        setTimeout(function() {
          const quantity = productCountInput.value;
          let totalPrice;
          let price;
          if (productSelect) {
            const val = productSelect.value;
            price = productSelect.querySelector(`option[value='${val}']`).dataset.price.replace('$', '');
     
            totalPrice = quantity * price;
          } else {
            totalPrice = +productSelect.dataset.firstPrice.replace('$', '') * +quantity;
          }
          console.log('totalprice', productCardPriceSwitcher)
          productCardPriceSwitcher.innerText = `$${totalPrice.toFixed(2)}`;
        }, 300);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      const quantity = formData.get('quantity');
      let productSelect = this.form.querySelector('select[name="Size"]');
      if (!productSelect) {
        productSelect = this.form.querySelector('select[name="Quantity"]');
      }
      let id = this.mainId;
      if (productSelect) {
      	const variantId = productSelect.selectedOptions[0].dataset.variantId;
          
          if (variantId) {
            id = variantId;
          }
      }
      config.body = JSON.stringify({
        id,
        quantity
      });
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          fetch(`${routes.cart_url}`, fetchConfig('javascript'))
            .then(r => r.json())
            .then(d => {
              this.cartCounter.innerText = d.item_count;
              this.cartCounterMobile.innerText = d.item_count;
              if (this.cartCounter.innerText !== '0') {
                this.cartCounter.style.display = 'inline-flex';
                this.cartCounterMobile.style.display = 'inline-flex';
              }
            })
            .catch(e => console.log(e));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('main-product-form')) {
  customElements.define('main-product-form', class ProductListForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartCounter = document.getElementById('cart-counter');
      this.cartCounterMobile = document.getElementById('cart-counter-mobile');
      this.mainId = this.querySelector('form input[name="id"]').value;
      this.productCardPriceSwitcher = document.getElementById('price-item-regular-' + this.mainId);

    }
  
    updatePrice() {
      let productSelect = this.form.querySelector('select[name="Size"]');
      console.log('selector', productSelect);
      if (!productSelect) {
        productSelect = this.form.querySelector('select[name="Quantity"]');
      }
      let firstPrice = productCardPriceSwitcher.dataset.firstPrice;
      if (productSelect) {
        firstPrice = productSelect.selectedOptions[0].dataset.price;
      }
      const productCountInput = document.querySelector('.product-list-count');
      const arrowUp = document.querySelector('.arrow-up');
      const arrowDown = document.querySelector('.arrow-down');
      productCardPriceSwitcher.innerText = firstPrice;

      productCountInput.addEventListener('input', calculateTotal);
      productCountInput.addEventListener('change', calculateTotal);
      arrowDown.addEventListener('click', calculateTotal);
      arrowUp.addEventListener('click', calculateTotal);

      if (productSelect) {
        productSelect.addEventListener('change', calculateTotal);
      }

      function calculateTotal (e) {
        setTimeout(function() {
          const quantity = productCountInput.value;
          let totalPrice;
          let price;
          if (productSelect) {
            const val = productSelect.value;
            price = productSelect.querySelector(`option[value='${val}']`).dataset.price.replace('$', '');
            totalPrice = quantity * price;
          } else {
            totalPrice = +productCardPriceSwitcher.dataset.firstPrice.replace('$', '') * +quantity;
          }
          productCardPriceSwitcher.innerText = `$${totalPrice.toFixed(2)}`;
        }, 300);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      const size = formData.get('Size');
      const quantity = formData.get('quantity');
      let productSelect = this.form.querySelector('select[name="Size"]');
      if (!productSelect) {
        productSelect = this.form.querySelector('select[name="Quantity"]');
      }
      let id = this.mainId;
      if (productSelect) {
      	const variantId = productSelect.selectedOptions[0].dataset.variantId;
          
          if (variantId) {
            id = variantId;
          }
      }
      config.body = JSON.stringify({
        id,
        quantity
      });
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          fetch(`${routes.cart_url}`, fetchConfig('javascript'))
            .then(r => r.json())
            .then(d => {
              this.cartCounter.innerText = d.item_count;
              this.cartCounterMobile.innerText = d.item_count;
              if (this.cartCounter.innerText !== '0') {
                this.cartCounter.style.display = 'inline-flex';
                this.cartCounterMobile.style.display = 'inline-flex';
              }
            })
            .catch(e => console.log(e));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

(function() {
    if (!customElements.get('frequently-asked-questions')) {
        class FrequentlyAskedQuestions extends HTMLElement {
            constructor() {
                super();

                this.faqHeaders = this.querySelectorAll(
                    '.frequently-asked-questions__faq-name button'
                );
                for (let i = 0; i < this.faqHeaders.length; i++) {
                    this.faqHeaders[i].addEventListener('click', (e) => {
                        e.preventDefault();
                        const header = this.querySelector(`.faq-name-${i + 1}`);
                        const button = header.querySelector('button');
                        const id = button.getAttribute('aria-controls');
                        const body = this.querySelector(`#${id}`);
                        if (body.classList.contains('expanded')) {
                            button.setAttribute('aria-expanded', false);
                            body.classList.remove('expanded');
                        } else {
                            button.setAttribute('aria-expanded', true);
                            body.classList.add('expanded');
                        }
                    });
                }
            }
        }
        customElements.define('frequently-asked-questions', FrequentlyAskedQuestions);
    }
})();

try {
function css_browser_selector(u){var ua=u.toLowerCase(),is=function(t){return ua.indexOf(t)>-1},g='gecko',w='webkit',s='safari',o='opera',m='mobile',h=document.documentElement,b=[(!(/opera|webtv/i.test(ua))&&/msie\s(\d)/.test(ua))?('ie ie'+RegExp.$1):is('firefox/2')?g+' ff2':is('firefox/3.5')?g+' ff3 ff3_5':is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')?g+' ff3':is('gecko/')?g:is('opera')?o+(/version\/(\d+)/.test(ua)?' '+o+RegExp.$1:(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')):is('konqueror')?'konqueror':is('blackberry')?m+' blackberry':is('android')?m+' android':is('chrome')?w+' chrome':is('iron')?w+' iron':is('applewebkit/')?w+' '+s+(/version\/(\d+)/.test(ua)?' '+s+RegExp.$1:''):is('mozilla/')?g:'',is('j2me')?m+' j2me':is('iphone')?m+' iphone':is('ipod')?m+' ipod':is('ipad')?m+' ipad':is('mac')?'mac':is('darwin')?'mac':is('webtv')?'webtv':is('win')?'win'+(is('windows nt 6.0')?' vista':''):is('freebsd')?'freebsd':(is('x11')||is('linux'))?'linux':'','js']; c = b.join(' '); h.className += ' '+c; return c;}; css_browser_selector(navigator.userAgent);
css_browser_selector();
} catch (e) {
  console.log(e.message);
}


  (function(){const appDomain="instafeed.nfcube.com",cssVer="4.0.7";var Instafeed=function(){function b(b){var c,d;for(c in this.options={target:"insta-feed",feedLoaded:!1,account:"",hash:"",forceUpdate:!1,picturesLoaded:0,admin:window.location.hostname===appDomain,title:"",columns:5},b)d=b[c],this.options[c]=d}return b.prototype.run=function(b){var c;if(c=this.options.target,c=document.getElementById(c),""===this.options.accessToken&&4===this.options.apiVersion)return c.innerHTML="<div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div><div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div><div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div><div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div>",c.innerHTML+="<div><em><b>Connect your Instagram account to see your feed</b></em></div>",!1;if(""===this.options.account&&2===this.options.apiVersion)return c.innerHTML+="<div><em><b>Please insert your Instagram username and press \"Save\" to see your feed</b></em></div>",!1;c.innerHTML="<img src='//instafeed.nfcube.com/assets/img/loader.gif' style='position:relative;height:11px;width:16px;' alt='loading bar' />";var d=this;const e=new XMLHttpRequest;return e.open("GET",b||this._buildUrl(),!0),e.onreadystatechange=function(){if(4===e.readyState){var b=e.status;if(0===b||200>=b&&400>b){var c=e.responseText.split(".parse (").pop().slice(0,-2);d.parse(JSON.parse(c))}else console.log("error")}},e.send(),!0},b.prototype.parse=function(b){var c,d,e,f,g,h,k,l,m,o,p,q,r,s,t,u,v,w,x;if(w=this.options.target,w=document.getElementById(w),"object"!=typeof b)throw new Error("Invalid JSON response");if(200!==b.meta.code)throw w.innerHTML="The access_token provided is invalid."===b.meta.error_message?this.options.admin?"<div class='alert error'><dl><dt>Your access token is invalid</dt><dd>Please generate a new <a href='https://instagram.pixelunion.net/' rel='noopener' target='_blank'>Instagram access token</a></span><br/><br/><div style='text-align:left;'><em>Instafeed doesn't have any control over your token. Your token is managed by Instagram and becomes invalid for security reasons. Example: you changed your Instagram password, someone tried to access your account and/or your Instagram account is compromised.</dd></dl></div>":"<em>Feed couldn't load. Token invalid.</em>":"<em>"+b.meta.error_message+"</em>",new Error("Error from API: "+b.meta.error_message);if(0===b.data.length)throw w.innerHTML="<em>No images were returned from this Instagram account</em>",new Error("No images were returned from Instagram");if(null===w)throw f="No element with id=\""+this.options.target+"\" on page.",new Error(f);if(null!==this.options.success&&"function"==typeof this.options.success&&this.options.success.call(this,b),"undefined"!=typeof document&&null!==document){q=b.data,g=document.createDocumentFragment(),h="",o="",r="",x=document.createElement("div");var y=w.clientWidth/this.options.columns*window.devicePixelRatio,z="standard_resolution",A=this.options.limit,B=parseFloat(100/this.options.columns).toFixed(6),C=parseInt(100-this.options.space);isMobileDevice()&&validateCharge(this.options.charge)&&(y=w.clientWidth/this.options.columnsMobile*window.devicePixelRatio,B=parseFloat(100/this.options.columnsMobile).toFixed(6),A=this.options.limitMobile),150>=y?z="thumbnail":320>=y&&(z="low_resolution");var D="",E="";validateCharge(this.options.charge)&&0<parseInt(this.options.likes)&&4!==parseInt(this.options.apiVersion)&&(D="<div class='likes'><span style='padding-right: 5px;'><svg width='10' height='10' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z' fill='white'></path></svg></span>{{likes}}<!--<span style='width: 10px;padding-right: 5px;padding-left: 5px;'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'><path d='M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z' fill='white'></path></svg></span> {{comments}}--></div>",E="<span><span style='padding-right: 5px;'><svg width='10' height='10' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z' fill='grey'></path></svg> {{likes}}</span> <!--<span>&#10078; {{comments}}</span>-->");var F="<div style='width:"+C+"%;height:"+C+"%;' class='instafeed-overlay {{video}}'>"+D+"</div>",G="<div class='instafeed-container' style='width:"+B+"%;padding-top:"+B+"%;'><img class='js-lazy-image' style='width:"+C+"%;height:"+C+"%;' src='//"+appDomain+"/assets/img/pixel.gif' data-src='{{image}}' alt='instagram post image' />"+F+"</div></div>",H="";for(1===parseInt(this.options.openIg)?G="<a href='{{link}}' target='_blank' rel='noopener'>"+G+"</a>":2===parseInt(this.options.openIg)?this.options.admin?G="<a href='"+this.options.shopOrigin+"/collections/all' target='_blank' rel='noopener'>"+G+"</a>":G="<a href='//"+window.location.hostname+"/collections/all'>"+G+"</a>":3===parseInt(this.options.openIg)&&(this.options.admin&&(H="<div class='products-tagging'><object><a href='#{{id}}-"+this.options.target+"' id='search' data-picture-id='{{fullId}}'><b><button class='primary'>Tag Product</button></b></a></object></div><em id='tagging-{{fullId}}'></em>"),G="<a href='#{{id}}-"+this.options.target+"'>"+G+"</a><a href='#_' class='instafeed-lightbox' id='{{id}}-"+this.options.target+"'><div class='lightbox-instagram'><div class='image'>{{imageFullHtml}}</div><div class='description'><div class='header'><object><a href='https://www.instagram.com/{{username}}' target='_blank' rel='noopener'><img src='//"+appDomain+"/assets/img/pixel.gif' class='profile-picture js-lazy-image' data-src='{{userPicture}}' alt='instagram user picture' /></a></object><object class='name-section'><a class='fullname' href='https://www.instagram.com/{{username}}/' target='_blank' rel='noopener'><span class='username'>{{username}}</span></a></object></div><hr><div class='box-content'><div class='sub-header'><div class='post-engagement'>"+E+"</div><div class='arrows'><object><a href='#{{minusId}}-"+this.options.target+"'><img src='//"+appDomain+"/assets/img/pixel.gif' alt='previous image' /></a></object><object><a href='#{{plusId}}-"+this.options.target+"'><img src='//"+appDomain+"/assets/img/pixel.gif' alt='next image' /></a></object></div></div>"+H+" {{taggedProduct}}<div class='instafeed-caption'>{{caption}}</div><div class='post-date'>{{date}} \u2022 <object><a href='{{link}}' target='_blank' rel='noopener' class='follow'>View on Instagram</a></object></div></div></div></div></a>"),k=0,t=q.length;k<t;k++){var I="";if(l=q[k],m=l.images[z],"object"!=typeof m)throw f="No image found for resolution: "+z+".",new Error(f);if(l.hasOwnProperty("tagged_products")&&0<l.tagged_products.length&&validateCharge(this.options.charge)){var J=this.options.admin,K=this.options.shopOrigin,L=this.options.target;l.tagged_products.forEach(function(b){J?(taggedProductUrl="<object class='product-title'><a href='https://"+K+"/products/"+b.handle+"/' target='_blank' rel='noopener'>"+b.title+"</a><a href='#{{id}}-"+L+"' id='delete-product' data-picture-id='{{fullId}}' data-tagging-id='"+b.id+"'><button class='tagged-buy-button'>Delete</button></a></object>",productImageUrl="<object><a href='https://"+K+"/products/"+b.handle+"/' target='_blank' rel='noopener'><img class='js-lazy-image' src='https://"+appDomain+"/assets/img/pixel.gif' data-src='"+b.image+"' alt='product image' /></a></object>"):!J&&(taggedProductUrl="<object class='product-title'><a href='//"+window.location.hostname+"/products/"+b.handle+"/'>"+b.title+"</a><a href='//"+window.location.hostname+"/products/"+b.handle+"/'><button class='tagged-buy-button'>Buy Now</button></a></object>",productImageUrl="<object><a href='//"+window.location.hostname+"/products/"+b.handle+"/'><img class='js-lazy-image' src='https://"+appDomain+"/assets/img/pixel.gif' data-src='"+b.image+"' alt='product image' /></a></object>"),I+="<div class='tagged-products' id='{{fullId}}-"+b.id+"'>"+productImageUrl+" "+taggedProductUrl+"</div>"})}var M="";if("video"===l.type&&l.hasOwnProperty("videos")?(M="instafeed-video",imageFullHtml="<video controls playsinline id=\"video-{{id}}-instafeed\" preload=\"none\" src=\""+l.videos.standard_resolution.url+"\"</video>"):imageFullHtml="<img class='js-lazy-image' src='//instafeed.nfcube.com/assets/img/pixel.gif' data-src='"+l.images.standard_resolution.url+"' alt='video thumbnail'>",p=m.url,o=this._makeTemplate(G,{model:l,id:this.options.picturesLoaded,fullId:l.id,minusId:0===this.options.picturesLoaded?A-1:this.options.picturesLoaded-1,plusId:this.options.picturesLoaded+1===A?0:this.options.picturesLoaded+1,link:l.link,image:p,video:M,username:l.user.username,fullName:l.user.full_name,userPicture:l.user.profile_picture,imageFullHtml:imageFullHtml,taggedProduct:I,date:timeConverter(l.created_time),caption:escapeHtml(this._getObjectProperty(l,"caption.text")),likes:shortenLargeNumber(l.likes.count,1),comments:shortenLargeNumber(l.comments.count,1),location:this._getObjectProperty(l,"location.name")}),0<parseInt(this.options.filter.length)&&validateCharge(this.options.charge)&&0===parseInt(this.options.public)){var N=l.tags.length,O=this.options.filter.replace("#","").replace(" ","").toLowerCase();O=O.split(",");loop1:for(a=0;a<N;a++)loop2:for(n=0;n<O.length;n++)if(l.tags[a]===printableChars(O[n])){h+=o,this.options.picturesLoaded++;break loop1}}else h+=o,this.options.picturesLoaded++;if(this.options.picturesLoaded>=A){this.options.admin&&3===parseInt(this.options.openIg)&&(h+="<em style=\"margin-top:15px;\"><i><b>Tip:</b> Click on a picture to start tagging products</i></em>");break}}for(x.innerHTML=h,e=[],d=0,c=x.childNodes.length;d<c;)e.push(x.childNodes[d]),d+=1;for(s=0,u=e.length;s<u;s++)v=e[s],g.appendChild(v);if(w.innerHTML="",0<this.options.title.length){var P=document.createElement("h2");P.innerHTML=this.options.title,w.insertBefore(P,w.firstChild)}w.appendChild(g)}return 4===parseInt(this.options.apiVersion)&&getProfilePic(b.data[0].user.username),lazyLoading(),!0},b.prototype._buildUrl=function(){var b,c,d;if(c=this.options.forceUpdate?1:0,d=/[^/]*$/.exec(window.location.href)[0],2===this.options.apiVersion){var e=this.options.limitMobile>this.options.limit?this.options.limitMobile:this.options.limit;b="https://instafeed.nfcube.com/api/v"+this.options.apiVersion+"?charge="+this.options.charge+"&fu="+c+"&limit="+e+"&filter="+parseInt(this.options.filter.length)+"&account="+this.options.account+"&tags="+this.options.filter+"&public="+this.options.public+"&hash="+this.options.hash+"&callback=cache.parse"}else if(4===this.options.apiVersion){var e=this.options.limitMobile>this.options.limit?this.options.limitMobile:this.options.limit;b="https://instafeed.nfcube.com/facebook/v4?charge="+this.options.charge+"&fu="+c+"&limit="+e+"&account="+this.options.shopOrigin+"&fid="+this.options.feedId+"&hash="+this.options.hash+"&callback=cache.parse"}else if(5===this.options.apiVersion){var e=this.options.limitMobile>this.options.limit?this.options.limitMobile:this.options.limit;b="https://instafeed.nfcube.com/facebook/v5?charge="+this.options.charge+"&fu="+c+"&limit="+e+"&account="+this.options.shopOrigin+"&fid="+this.options.feedId+"&hash="+this.options.hash+"&callback=cache.parse"}return b},b.prototype.slide=function(){console.log("slide")},b.prototype._makeTemplate=function(b,c){var d,e,f,g,h;for(e=/(?:\{{2})([\w\[\]\.]+)(?:\}{2})/,d=b;e.test(d);)g=d.match(e)[1],h=null===(f=this._getObjectProperty(c,g))?"":f,d=d.replace(e,function(){return""+h});return d},b.prototype._getObjectProperty=function(b,c){var d,e;for(c=c.replace(/\[(\w+)\]/g,".$1"),e=c.split(".");e.length;)if(d=e.shift(),null!==b&&d in b)b=b[d];else return null;return b},b}();function validateCharge(b){return!!(0<parseInt(b))}function getProfilePic(b){var c=new XMLHttpRequest;c.open("GET","https://www.instagram.com/"+b+"/?__a=1"),c.send(),c.onreadystatechange=function(){if(4==this.readyState&&200==this.status){let c=JSON.parse(this.responseText);var b=document.getElementsByClassName("profile-picture");for(let d of b)d.src=c.graphql.user.profile_pic_url_hd}}}function escapeHtml(b){return b&&(b=b.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;")),b}function shortenLargeNumber(b,c){for(var d,e=["k","M","G","T","P","E","Z","Y"],f=e.length-1;0<=f;f--)if(d=Math.pow(1e3,f+1),b<=-d||b>=d)return+(b/d).toFixed(c)+e[f];return b}function timeConverter(b){var c=new Date(1e3*b),d=c.toLocaleDateString(navigator.language,{month:"long",day:"numeric"});return d.toUpperCase()}function isMobileDevice(){return window.matchMedia("only screen and (max-width: 760px)").matches}function printableChars(b){return b.replace(/[^\x20-\x7E]+/g,"")}function lazyLoading(){function b(b){return new Promise((c,d)=>{const e=new Image;e.src=b,e.onload=c,e.onerror=d})}function c(c){const d=c.dataset.src;return d?b(d).then(()=>{e(c,d)}):void 0}function d(b){0===h&&g.disconnect();for(let d,e=0;e<b.length;e++)d=b[e],0<d.intersectionRatio&&(h--,g.unobserve(d.target),c(d.target))}function e(b,c){b.classList.add("js-lazy-image--handled"),b.src=c}const f=document.querySelectorAll(".js-lazy-image");let g,h=f.length;if(!("IntersectionObserver"in window))(function(b){for(let d,e=0;e<b.length;e++)d=b[e],c(d)})(f);else{g=new IntersectionObserver(d,{rootMargin:"100px 0px",threshold:.01});for(let b,c=0;c<f.length;c++)(b=f[c],!b.classList.contains("js-lazy-image--handled"))&&g.observe(b)}}(function(b,c){return"function"==typeof define&&define.amd?define([],c):"object"==typeof module&&module.exports?(module.exports=c(),module.exports):(b.Instafeed=c(),b.Instafeed)})(this,function(){return Instafeed}),function(){if(!document.currentScript.src.includes(appDomain))return!1;var b=document.createElement("link");b.href="https://instafeed.nfcube.com/cdn/instafeed-"+cssVer+".css",b.type="text/css",b.rel="stylesheet",b.media="screen,print",document.getElementsByTagName("head")[0].appendChild(b)}(),function(){function b(){"#_"===location.hash||0===location.hash.length?(document.body.style.overflow="visible",d=document.getElementById("video-"+c.substring(c.lastIndexOf("#")+1,c.lastIndexOf("-insta-feed"))+"-instafeed"),e&&(e.style.overflow="visible"),d&&(d.pause(),d.onplay=function(){"#_"===location.hash&&d.pause()})):location.hash.includes("-insta-feed")&&(document.body.style.overflow="hidden",e&&(e.style.overflow="hidden"),c=location.hash)}var c,d,e=document.getElementById("PageContainer");window.addEventListener("hashchange",b,!1)}();if(document.getElementById('insta-feed')!==null){var feed=new Instafeed({account:'',hash:'adb62e6d61f91bb2563f37f6657e5bc3',apiVersion:4,shopOrigin:'chaddsford-winery.myshopify.com',title:'',openIg:1,space:2,likes:1,filter:'',public:0,columns:3,feedId:0,columnsMobile:3,limit:6,limitMobile:6,charge:'0'});feed.run();}})();


// document.addEventListener('DOMContentLoaded', () => {
//   document.getElementById('insta-feed').classList.add('container');
// })

/*--------new js---------*/
$(document).ready(function(){
  if (window.location.href.indexOf("e-gift-card") > -1){
      setTimeout(function(){
        $(document).find('[name="Denominations"]').attr('name','Size');
      },500)   
  }
});
